import { render, staticRenderFns } from "./UserProducts.vue?vue&type=template&id=0b11555c&scoped=true&"
import script from "./UserProducts.vue?vue&type=script&lang=js&"
export * from "./UserProducts.vue?vue&type=script&lang=js&"
import style0 from "./UserProducts.vue?vue&type=style&index=0&id=0b11555c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b11555c",
  null
  
)

export default component.exports